export default "__VITE_ASSET__DJat9YXy__"